module.exports = __webpack_public_path__ + "img/6.517233c8.jpg";